import React, { useContext, useEffect } from 'react';
import { Typography, Grid, Card, CardContent, CardActionArea, Box, Container, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import StateContext from '../Contexts/StateContext';

// Ikonok vagy képek importálása (helyettesítő képek használata, amíg nincsenek specifikusak)
import summerTouristicImg from '../Assets/nyari.png';
import winterTouristicImg from '../Assets/teli.png';
import sajattermenyImg from '../Assets/sajattermek.png';
import nepviseletImg from '../Assets/nepviselet.png';
import panteonImg from '../Assets/panteon.png';
import nepiepiteszetImg from '../Assets/nepiepiteszet.png';
import futuristiqueImg from '../Assets/Futuristique/futuristique.png';
import balladaImg from '../Assets/SzekelyNepballadak.png';
import nepdalImg from '../Assets/SzekelyNepdalok.png';
import locsoloversImg from '../Assets/Locsoloversek.png';
import touristicImg from '../Assets/image1.jpg';

import geologicalImg from '../Assets/autok.png';
import floraImg from '../Assets/image12.jpg';
import mineralWaterImg from '../Assets/image16.jpg';
import builtHeritageImg from '../Assets/hadnagyhenter.png';
import propertyImg from '../Assets/property.png';

import hotelImg from '../Assets/hotel.png';
import guesthouseImg from '../Assets/kulcsoshaz.png';
import barnImg from '../Assets/csur.png';
import campingImg from '../Assets/camping.png';

function AddMapObject() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const GlobalState = useContext(StateContext);

  useEffect(() => {
    if (!GlobalState.userIsLogged) {
        navigate('/login');
    }
  }, [GlobalState.userIsLogged, navigate]);

  const marketCategories = [
    {
      id: 'ingatlan',
      title: t('SubMenu.Property'),
      path: '/addproperty',
      image: propertyImg,
      description: t('MapObject.PropertyDesc', 'Eladó vagy kiadó ingatlanok rögzítése.')
    },
    {
      id: 'sajat-termeny',
      title: t('SubMenu.OwnProduce'),
      path: '/sajat-termeny-hozzaadasa',
      image: sajattermenyImg,
      description: t('MapObject.OwnProduceDesc', 'Helyi termények és kézműves termékek rögzítése.')
    },
    {
      id: 'auto',
      title: t('SubMenu.Car'),
      path: '/addcar',
      image: geologicalImg,
      description: t('MapObject.CarDesc', 'Gépjárművek rögzítése.')
    },
    {
      id: 'teli-sport',
      title: t('SubMenu.WinterSports'),
      path: '/add-winter-sport',
      image: winterTouristicImg,
      description: t('MapObject.WinterSportsDesc', 'Téli sportfelszerelések rögzítése.')
    },
    {
      id: 'nyari-sport',
      title: t('SubMenu.SummerSports'),
      path: '/add-summer-sport',
      image: summerTouristicImg,
      description: t('MapObject.SummerSportsDesc', 'Nyári sportfelszerelések rögzítése.')
    }
  ];

  const sightCategories = [
    {
      id: 'built-heritage',
      title: t('SubMenu.BuiltHeritage'),
      path: '/add-sight/built-heritage', 
      image: builtHeritageImg,
      description: t('MapObject.BuiltHeritageDesc', 'Kúriák, kastélyok és egyéb épített örökségek rögzítése.')
    },
    {
      id: 'rovasemlek',
      title: t('SubMenu.RunicScripts'),
      path: '/add-sight/rovasemlek',
      image: touristicImg,
      description: t('MapObject.RunicScriptsDesc', 'Rovásemlékek és történelmi feliratok rögzítése.')
    },
    {
      id: 'neprajzi',
      title: t('SubMenu.Ethnographic'),
      path: '/add-sight/neprajzi',
      image: touristicImg,
      description: t('MapObject.EthnographicDesc', 'Néprajzi értékek és gyűjtemények rögzítése.')
    },
    {
      id: 'egyhazi',
      title: t('SubMenu.Spiritual'),
      path: '/add-sight/egyhazi',
      image: touristicImg,
      description: t('MapObject.SpiritualDesc', 'Templomok, kápolnák és egyházi emlékek rögzítése.')
    },
    {
      id: 'geological',
      title: t('SubMenu.Geological'),
      path: '/add-sight/geological',
      image: geologicalImg,
      description: t('MapObject.GeologicalDesc', 'Földtani képződmények és látnivalók rögzítése.')
    },
    {
      id: 'novenyvilag',
      title: t('SubMenu.Botanical'),
      path: '/add-sight/novenyvilag',
      image: floraImg,
      description: t('MapObject.BotanicalDesc', 'Botanikai értékek, különleges növények rögzítése.')
    },
    {
      id: 'mineral-water',
      title: t('SubMenu.MineralWater'),
      path: '/add-sight/mineral-water',
      image: mineralWaterImg,
      description: t('MapObject.MineralWaterDesc', 'Borvizek, források és mofetták rögzítése.')
    },
    {
      id: 'gyalogtura',
      title: t('SubMenu.Tracking'),
      path: '/add-sight/gyalogtura',
      image: touristicImg,
      description: t('MapObject.TrackingDesc', 'Gyalogtúrák és turistaösvények rögzítése.')
    },
    {
      id: 'lovastura',
      title: t('SubMenu.Equestrian'),
      path: '/add-sight/lovastura',
      image: touristicImg,
      description: t('MapObject.EquestrianDesc', 'Lovastúrák és lovas útvonalak rögzítése.')
    }
  ];

  const businessCategories = [
    {
      id: 'cegek',
      title: t('SubMenu.Companies'),
      path: '/uzleti-regisztracio',
      image: touristicImg,
      description: t('MapObject.CompaniesDesc', 'Helyi cégek és vállalkozások rögzítése.')
    },
    {
      id: 'mesterek',
      title: t('SubMenu.Masters'),
      path: '/uzleti-regisztracio',
      image: touristicImg,
      description: t('MapObject.MastersDesc', 'Szakemberek és mesteremberek rögzítése.')
    },
    {
      id: 'napszamosok',
      title: t('SubMenu.DayLabourers'),
      path: '/uzleti-regisztracio',
      image: touristicImg,
      description: t('MapObject.DayLabourersDesc', 'Napszámosok és alkalmi munkavállalók rögzítése.')
    }
  ];

  const accommodationCategories = [
    {
      id: 'pension',
      title: t('SubMenu.Pension'),
      path: '/addaccommodation',
      image: touristicImg,
      description: t('MapObject.PensionDesc', 'Panziók és vendégházak rögzítése.')
    },
    {
      id: 'hotel',
      title: t('SubMenu.Hotel'),
      path: '/addaccommodation',
      image: hotelImg,
      description: t('MapObject.HotelDesc', 'Szállodák és hotelek rögzítése.')
    },
    {
      id: 'guesthouse',
      title: t('SubMenu.Guesthouse'),
      path: '/addaccommodation',
      image: guesthouseImg,
      description: t('MapObject.GuesthouseDesc', 'Kulcsosházak és magánszállások rögzítése.')
    },
    {
      id: 'barn',
      title: t('SubMenu.Barn'),
      path: '/addaccommodation',
      image: barnImg,
      description: t('MapObject.BarnDesc', 'Hagyományos csűrök és különleges szálláshelyek rögzítése.')
    },
    {
      id: 'camping',
      title: t('SubMenu.Camping'),
      path: '/addaccommodation',
      image: campingImg,
      description: t('MapObject.CampingDesc', 'Sátorhelyek és kempingek rögzítése.')
    }
  ];

  const thematicCategories = [
    {
      id: 'nepviselet',
      title: t('Thematic.FolkCostume', 'Népviselet'),
      path: '/add-thematic/nepviselet',
      image: nepviseletImg,
      description: t('Thematic.FolkCostumeDesc', 'Népviseleti adatok rögzítése.')
    },
    {
      id: 'nepi-epiteszet',
      title: t('Thematic.FolkArchitecture', 'Népi építészet'),
      path: '/add-thematic/nepi_epiteszet',
      image: nepiepiteszetImg,
      description: t('Thematic.FolkArchitectureDesc', 'Népi építészeti emlékek rögzítése.')
    },
    {
      id: 'panteon',
      title: t('Thematic.Pantheon', 'Panteon'),
      path: '/add-thematic/panteon',
      image: panteonImg,
      description: t('Thematic.PantheonDesc', 'Híres székelyek és történelmi személyek rögzítése.')
    },
    {
      id: 'futuristique',
      title: t('Thematic.Futuristique', 'Futuristique'),
      path: '/add-thematic/futuristique',
      image: futuristiqueImg,
      description: t('Thematic.FuturistiqueDesc', 'Jövőbeli tervek és víziók rögzítése.')
    },
    {
      id: 'ballada',
      title: t('Thematic.Ballads', 'Balladák'),
      path: '/add-thematic/ballada',
      image: balladaImg,
      description: t('Thematic.BalladsDesc', 'Székely népballadák rögzítése.')
    },
    {
      id: 'nepdal',
      title: t('Thematic.FolkSongs', 'Népdalok'),
      path: '/add-thematic/nepdal',
      image: nepdalImg,
      description: t('Thematic.FolkSongsDesc', 'Székely népdalok rögzítése.')
    },
    {
      id: 'locsoloversek',
      title: t('Thematic.EasterVerses', 'Locsolóversek'),
      path: '/add-thematic/locsoloversek',
      image: locsoloversImg,
      description: t('Thematic.EasterVersesDesc', 'Locsolóversek rögzítése.')
    },
    {
      id: 'esemeny',
      title: t('Events.SzeklerlandEvents', 'Székelyföldi események'),
      path: '/szekelyfoldi-esemenyek',
      state: { openAddDialog: true },
      image: touristicImg,
      description: t('MapObject.EventDesc', 'Kulturális, sport és közösségi események rögzítése.')
    }
  ];

  const CategoryCard = ({ cat }) => (
    <Grid item xs={12} sm={6} md={4} key={cat.id}>
      <Card sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        height: '100%',
        transition: 'transform 0.2s',
        '&:hover': { transform: 'scale(1.02)', boxShadow: 6 }
      }}>
        <CardActionArea 
          onClick={() => navigate(cat.path, { state: cat.state })}
          sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
        >
          <Box sx={{ height: '240px', overflow: 'hidden' }}>
            <img 
              src={cat.image} 
              alt={cat.title} 
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Box>
          <CardContent sx={{ flexGrow: 1 }}>
            <Typography variant="h5" component="h2" sx={{ color: '#105b79', fontWeight: 'bold' }}>
              {cat.title}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, sm: 2 }, mt: '100px' }}>
      <Box sx={{ mb: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <Typography variant={isMobile ? "h4" : "h3"} align="center" sx={{ color: '#105b79', fontWeight: 'bold' }}>
          {t('SubMenu.MapObject') + " +"}
        </Typography>
        <Typography variant="body1" align="center" sx={{ maxWidth: '800px', fontSize: { xs: '0.9rem', md: '1rem' } }}>
          {t('MapObject.Intro', 'Válassza ki a térképobjektum típusát, amelyet rögzíteni szeretne a Székely Honismereti Térképre.')}
        </Typography>
      </Box>

      {/* Market categories first */}
      <Box sx={{ mb: 6 }}>
        <Typography variant={isMobile ? "h5" : "h4"} sx={{ color: '#105b79', fontWeight: 'bold', mb: 3, borderBottom: '2px solid #105b79', pb: 1 }}>
          {t('Header.Piacter')}
        </Typography>
        <Grid container spacing={isMobile ? 2 : 4}>
          {marketCategories.map((cat) => (
            <CategoryCard key={cat.id} cat={cat} />
          ))}
        </Grid>
      </Box>

      {/* Thematic Maps */}
      <Box sx={{ mb: 6 }}>
        <Typography variant={isMobile ? "h5" : "h4"} sx={{ color: '#105b79', fontWeight: 'bold', mb: 3, borderBottom: '2px solid #105b79', pb: 1 }}>
          {t('Header.ThematicMaps', 'TEMATIKUS TÉRKÉPEK')}
        </Typography>
        <Grid container spacing={isMobile ? 2 : 4}>
          {thematicCategories.map((cat) => (
            <CategoryCard key={cat.id} cat={cat} />
          ))}
        </Grid>
      </Box>

      {/* Sights */}
      <Box sx={{ mb: 6 }}>
        <Typography variant={isMobile ? "h5" : "h4"} sx={{ color: '#105b79', fontWeight: 'bold', mb: 3, borderBottom: '2px solid #105b79', pb: 1 }}>
          {t('Header.Latnivalok')}
        </Typography>
        <Grid container spacing={isMobile ? 2 : 4}>
          {sightCategories.map((cat) => (
            <CategoryCard key={cat.id} cat={cat} />
          ))}
        </Grid>
      </Box>

      {/* Businesses */}
      <Box sx={{ mb: 6 }}>
        <Typography variant={isMobile ? "h5" : "h4"} sx={{ color: '#105b79', fontWeight: 'bold', mb: 3, borderBottom: '2px solid #105b79', pb: 1 }}>
          {t('Header.CegekMesterek')}
        </Typography>
        <Grid container spacing={isMobile ? 2 : 4}>
          {businessCategories.map((cat) => (
            <CategoryCard key={cat.id} cat={cat} />
          ))}
        </Grid>
      </Box>

      {/* Accommodation */}
      <Box sx={{ mb: 6 }}>
        <Typography variant={isMobile ? "h5" : "h4"} sx={{ color: '#105b79', fontWeight: 'bold', mb: 3, borderBottom: '2px solid #105b79', pb: 1 }}>
          {t('Header.Szallas')}
        </Typography>
        <Grid container spacing={isMobile ? 2 : 4}>
          {accommodationCategories.map((cat) => (
            <CategoryCard key={cat.id} cat={cat} />
          ))}
        </Grid>
      </Box>
    </Container>
  );
}

export default AddMapObject;
